<template>
    <div class="container bg-white header-contato" v-if="cursos && assuntos">
        <div class="row justify-content-center pt-xl-5 pt-3">
            <div class="col-xl-5 pb-xl-4 pb-1 mt-2 mt-xl-0">
                <div class="font-glacial-bold font-30 text-uppercase text-xl-left text-center">
                    <h1 class="mt-2 mb-xl-5 mb-3 font-glacial-bold font-30 text-uppercase text-xl-left text-center">
                        {{data.titulo}}
                    </h1>
                </div>
                <div class="font-glacial-regular font-16 text-gray-light text-xl-left text-center">
                    <h3 class="font-glacial-regular font-16 text-gray-light text-xl-left text-center">
                        {{data.descricao}}
                    </h3>
                </div>
            </div>
            <div class="col-xl-5 pb-xl-4 d-flex justify-content-end align-items-center">
                <div class="send-icon d-none d-xl-block">
                </div>
            </div>
        </div>
        <form>
            <div class="row justify-content-center pb-5">
                <div class="col-xl-5">

                    <div class="pt-4 input-group">
                        <span class="input-group-addon">
                            <div class="icon person-icon"></div>
                        </span>
                        <b-form-input class="form-control form-field padding-input"
                            v-model="formData.nome" 
                            type="text" 
                            placeholder="SEU NOME" 
                            onfocus="this.placeholder=''" 
                            onblur="this.placeholder='SEU NOME'"
                        />
                    </div>
                    <div class="text-center height-0 text-error-msg" v-if="errors && errors.nome">
                        {{errors.nome[0]}}
                    </div>

                    <div class="pt-5 input-group">
                        <span class="input-group-addon">
                            <div class="icon email-icon"></div>
                        </span>
                        <b-form-input class="form-control form-field padding-input" 
                            v-model="formData.email" 
                            type="email" 
                            placeholder="E-MAIL" 
                            onfocus="this.placeholder=''" 
                            onblur="this.placeholder='E-MAIL'"
                        ></b-form-input>
                    </div>
                    <div class="text-center height-0 text-error-msg" v-if="errors && errors.email">
                        {{errors.email[0]}}
                    </div>

                    <div class="pt-5 input-group">
                        <span class="input-group-addon">
                            <div class="icon phone-icon"></div>
                        </span>
                        <b-form-input class="form-control form-field padding-input"
                            v-model="formData.telefone" type="text" 
                            v-mask="'(##) #####-####'"
                            placeholder="CELULAR" 
                            onfocus="this.placeholder=''" 
                            onblur="this.placeholder='CELULAR'"
                        ></b-form-input>
                    </div>
                    <div class="text-center text-error-msg height-0" v-if="telefoneError">
                        {{telefoneError}}
                    </div>

                    <div class="pt-5">
                        <v-select label="nome" class="form-control form-field"
                            placeholder="BAUHAUS"
                            v-model="bauhaus"
                            :options="['Ribeirão Preto - SP', 'Piracicaba - SP']"
                        ></v-select>
                        <!-- <b-form-select 
                            v-model="formData.bauhaus"  
                            type="text" 
                            placeholder="BAUHAUS" 
                            onfocus="this.placeholder=''" 
                            onblur="this.placeholder='BAUHAUS'" class="mb-3 form-control form-field">
                            <template slot="first">
                                <option :value="''" disabled>BAUHAUS</option>
                            </template>
                            <option class="text-uppercase" :value="'Ribeirão Preto - SP'">Ribeirão Preto - SP</option>
                            <option class="text-uppercase" :value="'Piracicaba - SP'">Piracicaba - SP</option>
                        </b-form-select> -->
                    </div>
                    <div class="text-center height-0 text-error-msg" v-if="errors && errors.bauhaus">
                        {{errors.bauhaus[0]}}
                    </div>

                </div>

                <div class="col-xl-5">
                    <div class="pt-4">
                        <v-select label="nome" class="form-control form-field"
                            placeholder="ASSUNTO"
                            v-model="assunto"
                            :options="assuntos"
                        />
                    </div>
                    <div class="text-center height-0 text-error-msg" v-if="errors && errors.assunto">
                        {{errors.assunto[0]}}
                    </div>
                    
                    <div class="pt-5">
                        <b-form-textarea class="form-control form-field textarea-contato" 
                            rows=4 v-model="formData.mensagem" 
                            type="text" 
                            placeholder="SUA MENSAGEM" 
                            onfocus="this.placeholder=''" 
                            onblur="this.placeholder='SUA MENSAGEM'"
                        ></b-form-textarea>
                    </div>
                    <div class="text-center height-0 text-error-msg" v-if="errors && errors.mensagem">
                        {{errors.mensagem[0]}}
                    </div>

                    <div class="pt-4 mt-3 input-group" v-if="cursos">
                        <v-select label="nome" class="form-control form-field" style="height: auto;"
                            placeholder="CURSO"
                            v-model="curso"
                            :options="cursos"
                        />
                    </div>
                    <div class="text-center height-0 text-error-msg" v-if="errors && errors.curso">
                        {{errors.curso[0]}}
                    </div>

                </div>

                <div class="pt-5">
                    <b-alert show variant="success" v-if="success">
                        {{success}}
                    </b-alert>
                    <b-alert show variant="warning mt-3 mt-xl-0" v-if="error">
                        {{error}}
                    </b-alert>
                </div>

            </div>
            <div class="row justify-content-center pt-0">
                <div class="col-xl-5 mb-4 pb-xl-4">
                    <div class="font-glacial-regular font-16 text-gray-light text-xl-left text-center">
                        {{data.aviso}}
                    </div>
                </div>
                <div class="col-xl-5 mb-4 pb-xl-4 align-items-center">
                    <div class="d-flex justify-content-xl-end justify-content-center mt-3 mt-xl-0 btn-opacidade">
                        <div>
                            <b-btn type="button" class="btn btn-enviar btn-pointer btn-opacidade" @click="submit" :disabled="loading">
                                <span v-if="!loading">ENVIAR</span>
                                <span v-else>ENVIANDO ...</span>
                            </b-btn>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="row mt-4 pt-xl-3 justify-content-center">
            <div class="col-xl-5 col-lg-5 col-md-5 mb-4 pb-4" v-for="(d, index) in data.localizacao" :key="index">
                <a v-bind:href="d.link" target="_blank">
                <div class="row align-items-center mb-3">
                    <div class="col-1">
                        <div class="location-icon"></div>
                    </div>
                    <div class="ml-1 ml-xl-0 font-glacial-bold font-black font-24">
                        {{d.cidade}}
                    </div>
                </div>
                    <div class="font-glacial-regular font-16 text-gray-light">
                        {{d.endereco}}
                    </div>
                    <div class="bg-line">
                    </div>
                    <div class="font-glacial-regular font-16 text-gray-light">
                        {{d.telefone}}
                    </div>
                    <div class="font-glacial-regular font-16 text-gray-light">
                        {{d.email}}
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        data: null
    },
    data(){
        return{
            success: null,
            errors: null,
            telefoneError: null,
            error: null,
            loading: false,
            selected: null,

            curso: null,
            assunto: null,
            bauhaus: null,
            formData: {
                nome: '',
                email: '',
                assunto: '',
                telefone: '',
                mensagem: '',
                curso: '',
                bauhaus: '',
            }
        }
    },

    created(){
        if(this.$route.query.email){
            this.form.email = this.$route.query.email
        }
        if(this.$route.params.area){
            this.formData.curso = this.$route.params.area

            for (let i = 0; i < this.cursos.length; i++) {
                if(this.cursos[i].id == this.$route.params.area){
                    this.curso = this.cursos[i]
                }
            }
        }
    },

    methods:{
        showError(field){
            if(this.errors && this.errors.invalidFields){
                for (let index = 0; index < this.errors.invalidFields.length; index++) {
                    const e = this.errors.invalidFields[index];

                    if (e.into.includes(field)){
                        return e.message
                    }
                    
                }
            }

            return null;
        },
        async serialize(obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        },

        async submit(){
            if (this.errors && this.errors.message) {
                this.errors.message = null
            }

            if(this.curso){
                this.formData.curso = this.curso.id 
            }
            if(this.assunto){
                this.formData.assunto = this.assunto.id 
            }

            this.loading = true
            this.errors  = null
            this.telefoneError = null

            if(this.bauhaus == "Ribeirão Preto - SP"){
                this.formData.bauhaus = 1
            } else if(this.bauhaus == "Piracicaba - SP"){
                this.formData.bauhaus = 2
            }

            if (this.formData.telefone == '') {
                this.telefoneError = 'Este campo é obrigatório.'
            }
            
            var query = await this.serialize(this.formData);
            try {
                var response = await axios.get('http://manager.escolabauhaus.com.br/fale-conosco/post?' + query);
                
                if(response.data && response.data != 1){
                    this.errors = response.data
                    this.error = 'Erro ao enviar os dados do formulário'
                } 
                
                if(response.data == 1) {
                    this.success = 'Formulário enviado com sucesso'
                    this.error   = null

                    this.formData.nome     = '';
                    this.formData.email    = '';
                    this.formData.assunto  = '';
                    this.formData.telefone = '';
                    this.formData.mensagem = '';
                    this.formData.curso    = '';
                    this.formData.bauhaus  = '';
                    this.assunto = null
                    this.bauhaus = null

                    if (!this.$route.params.area) {
                        this.curso = null
                    }

                    setTimeout(() => {
                        this.success = ''
                    }, 6 * 1000)
                }
            } catch (e) {
                console.log(e)
            }

            this.loading = false
        }
    },

    computed: {
        cursos(){
            return this.$store.state.post.cursosApi
        },

        assuntos(){
            return this.$store.state.post.AssuntosApi.assuntos
        },
    },

}
</script>



// WEBPACK FOOTER //
// src/components/widgets/contato.vue